(function() {
    Header.$inject = ['$scope', '$http', '$location', '__env', 'toastr', 'httpService', 'readCookie', '$log'];

    angular.module('app')
        .component('headerComponent', {
            templateUrl: 'common/components/header/header.html',
            controller: Header,
            bindings: {
                headerOptions: '=',
                userOptions: '='
            }
        });

    /**
     * Header file for admin controls
     *
     * @class Header
     * @param { Object } $scope - The scope of the controller.
     * @param { Object } $http - The Angular $http service.
     * @param { Object } $location - The Angular $location service.
     * @param { Object } $translate - The translation service.
     * @param { Object } __env - The environment configuration.
     * @param { Object } toastr - The third party toaster service.
     * @param { Object } httpService - The service to send http calls.
     * @param { service } $log - The service to log to console (or to file if needed).
     */
    function Header($scope, $http, $location, __env, toastr, httpService, readCookie, $log){
        'ngInject';

        var portals = this.userOptions;
        $scope.acms = [];
        $scope.admins = [];
        $scope.menuOptions = [{name: 'Portal Selection', url: __env.currentUrl + '#/portalList'}];
        $scope.secondaryMenuOptions = [];

        for (var i = 0; i < portals.length; i++) {
            if (portals[i].portalTypeId === 2) {
                $scope.acms.push(portals[i]);
            } else if (portals[i].portalTypeId === 1) {
                $scope.admins.push(portals[i]);

                // set the menu based on portals user can access
                // this can be cleaned up
                if (portals[i].portalName === 'User Management' ||
                        portals[i].portalName === 'Portal Management' ||
                        portals[i].portalName === 'Report Portal') {

                    $scope.menuOptions.push({
                        name: portals[i].portalName,
                        url: portals[i].baseUri + portals[i].homePageRelativeUri
                    });
                } else {
                     $scope.secondaryMenuOptions.push({
                        name: portals[i].portalName,
                        url: portals[i].baseUri + portals[i].homePageRelativeUri
                    });
                }
            }
        }

        $scope.userEmail = readCookie.getByName(__env.emailCookieName);
        $scope.portalList = {};
        $scope.showSecondaryMenu = false;
        $scope.pageTitle = this.headerOptions.projectName;
        $scope.languages = this.headerOptions.languages;

        if ($scope.secondaryMenuOptions.length > 0) {
            $scope.showSecondaryMenu = true;
        }

        /**
         * Creates the cookie used for authentication
         *
         * @function createCookie
         * @param { string } name - name of the cookie
         * @param { string } value - value of the cookie
         * @param { string } expires - When the cookie will expires
         */
        $scope.createCookie = function(name, value, expires) {
            // Domain -- This should likely be .dev.assentcompliance.com for dev instances instead of a catch-all
            console.log('code', __env);
            document.cookie = name + '=' + value + ';expires=' + expires + ';domain=' + __env.domain + ';';
        };


        /**
         * clears the cookies and logs the user out. Redirects to login page on
         * success or failure
         *
         * @function
         * @param { string } name - name of the cookie
         */
        $scope.logout = function () {
            // set the expiry on the cookie
            $scope.createCookie('sessionKey', '', new Date().getTime());
            $scope.createCookie('email', '', new Date().getTime());

            var url = __env.apiBaseUrl + '/login/logout/' + readCookie.getByName(__env.sessionCookieName);
            var type = 'post';
            var data = '';

            httpService.asyncCall(url, type, data)
                .then(function (response) {
                    location.href = __env.loginPage;
                }).catch(function (e) {
                    var message = 'Status: ' + e.status +
                        '; Error:' + e.statusText;

                    $log.error(message);
                    location.href = __env.loginPage;
                });
        };
    };
})();
